import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-18",
  style: {"text-align":"left"}
}
const _hoisted_4 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"text-align":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-row ss-grade-personalizada-titulo",
  style: {"margin-top":"6px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-18",
    style: {"text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Controle")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-6",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)
const _hoisted_6 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-18",
  style: {"text-align":"left"}
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"text-align":"center"}
}
const _hoisted_9 = { class: "acoes-item" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_controle_producao = _resolveComponent("selecionar-controle-producao")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_selecionar_controle_producao, {
                    varios: false,
                    "codigo-selecionado": _ctx.state.codigo,
                    "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigo) = $event)),
                    descricaoSelecionado: _ctx.state.descricaoSelecionado,
                    "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.descricaoSelecionado) = $event)),
                    empresas: _ctx.props.empresas,
                    disabled: false,
                    style: {"text-align":"left"}
                  }, null, 8, ["codigo-selecionado", "descricaoSelecionado", "empresas"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary",
                    style: {"width":"100%"},
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.adicionar && _ctx.adicionar(...args)))
                  }, _toDisplayString(_ctx.state.codigoProdutoSelecionado === -1 ? 'Adicionar' : 'Editar'), 1)
                ])
              ]),
              _hoisted_5,
              (!_ctx.UtilitarioGeral.validaLista(_ctx.computedControle))
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    mensagem: "Nenhum Controle Informado!"
                  }))
                : (_openBlock(), _createBlock(_component_a_form, {
                    key: 1,
                    name: "ss-form-controle-producao",
                    class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedControle, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ant-row ss-grade-personalizada-linha",
                          key: item.codigo
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("input", {
                              class: "ant-input",
                              type: "text",
                              value: item.descricao,
                              disabled: "true",
                              style: {"text-align":"left"}
                            }, null, 8, _hoisted_7)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.editar(index))
                              }, [
                                _createVNode(_component_icone, { nome: "editar" })
                              ], 8, _hoisted_10),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.excluir(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_11)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}